// this hook is used to preprocess the value before passing it to the select component
// by filtering out any initial values that are not in the items list
// which can happen when a value is stored in redux and the items list is updated in the meantime
export const usePreProcessValue = ({items, value, valueField, multiple}) => {
	const flatItems = items.flatMap(i => (i.subItems ? i.subItems : i))
	const initialValues = flatItems._map(valueField)
	value = multiple && !_.isArray(value) ? [] : value
	value = multiple ? value.filter(v => initialValues.includes(v)) : value

	return value
}
